import { useOnlineStatus } from "./use-online-status";

export function OfflineFallback() {
  const online = useOnlineStatus();
  if (online) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 16,
        left: "50%",
        transform: "translateX(-50%)",
        padding: "10px 16px",
        borderRadius: 10,
        background: "hsl(var(--c-card-elevated))",
        border: "1px solid hsl(var(--c-border))",
        boxShadow: "var(--shadow-lg)",
        zIndex: 9998,
        display: "flex",
        alignItems: "center",
        gap: 8,
      }}
    >
      <span style={{ fontSize: 14 }}>📴</span>
      <span className="p-small">
        You are offline. Scenarios are read-only until connection is restored.
      </span>
    </div>
  );
}
